export function getCadastrosAreas(t) {
    return [
        {
            key: 'inicio',
            title: t('cadastros.areas.inicio'),
            route: '/cadastros',
            exactMatch: true,
            isDefault: true,
        },
        {
            key: 'clientes',
            title: t('cadastros.areas.clientes'),
            route: '/cadastros/clientes',
            shortcutDescription: t('cadastros.shortcuts.clientes.description'),
        },
        {
            key: 'fornecedores',
            title: t('cadastros.areas.fornecedores'),
            route: '/cadastros/fornecedores',
            shortcutDescription: t('cadastros.shortcuts.fornecedores.description'),
        },
        {
            key: 'servicos',
            title: t('cadastros.areas.servicos'),
            route: '/cadastros/servicos',
            shortcutDescription: t('cadastros.shortcuts.servicos.description'),
        },
        {
            key: 'categorias',
            title: t('cadastros.areas.categorias'),
            route: '/cadastros/categorias',
            shortcutDescription: t('cadastros.shortcuts.categorias.description'),
        },
        {
            key: 'centros-custo',
            title: t('cadastros.areas.centros-custo'),
            route: '/cadastros/centros-custo',
            shortcutDescription: t('cadastros.shortcuts.centros-custo.description'),
        },
    ];
}
export function getCadastrosTabs(t) {
    return getCadastrosAreas(t);
}
export function getCadastrosShortcuts(t) {
    return getCadastrosAreas(t).filter(area => !area.isDefault);
}
